import { StyledMobileHeader } from './style';
import PublicRoute from 'enums/publicRoutes';
import { useIntl } from 'react-intl';
import { useProductState } from 'public/context';
import { useLocation, useNavigate } from 'react-router-dom';
import MobileHeaderMap from './MobileHeaderMap/MobileHeaderMap';
import { Icon } from 'ui';
import useMarketType from 'utils/useMarketType';

const MobileHeader = () => {
  const intl = useIntl();
  const location = useLocation();
  const { productsCounted } = useProductState();
  const navigate = useNavigate();
  const { isEmarket } = useMarketType();

  return (
    <StyledMobileHeader>
      <div id="mobile-header-container" className={'mobile-header-container'}>
        <div className="mobile-image-container" onClick={() => navigate(isEmarket ? PublicRoute.HOME : PublicRoute.WHOLESALE_PRODUCTS_ALL)}>
          <Icon name="mobile-header-img-left" type={'header'} />
          <img src={isEmarket ? '/mobile-header-img-logo.png' : '/mobile-header-image-wholesale-logo.png'} alt="mob-header" />
          <Icon name="mobile-header-img-right" type={'header'} />
        </div>

        {location.pathname.includes(PublicRoute.FARMS_ALL) && <MobileHeaderMap />}
        {location.pathname === PublicRoute.HOME && (
          <div className={'buy-latvia-food'}>
            <div className={'title-section'}>
              <h3>
                {intl.formatMessage({
                  id: 'mobile_header.buy_latvia_food_buy',
                })}
                <b>
                  {intl.formatMessage({
                    id: 'mobile_header.buy_latvia_food__latvia',
                  })}
                </b>
                {intl.formatMessage({
                  id: 'mobile_header.buy_latvia_food',
                })}
              </h3>
            </div>

            <div className={'counter-section'}>
              <h3>
                <b>{productsCounted}</b>
              </h3>
              <h3>{intl.formatMessage({ id: 'general.products' })}</h3>
            </div>
          </div>
        )}
      </div>
    </StyledMobileHeader>
  );
};

export default MobileHeader;
